import * as THREE from 'three';

export function createMaterials(tex) {
  const wood = new THREE.MeshPhysicalMaterial({
    map: tex.wood,
    roughnessMap: tex.woodRough,
    bumpMap: tex.woodBump,
    bumpScale: 0.0014,
    color: new THREE.Color('#e0b07a'),
    roughness: 0.48,
    metalness: 0.02,
    clearcoat: 0.28,
    clearcoatRoughness: 0.45,
    sheen: 0.18,
    sheenColor: new THREE.Color('#8a4a22'),
    sheenRoughness: 0.7,
  });

  const woodDark = wood.clone();
  woodDark.color = new THREE.Color('#8a4a28');
  woodDark.roughness = 0.5;

  const inner = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color('#4a2a18'),
    roughness: 0.86,
    metalness: 0,
    map: tex.pegWood,
  });

  const peg = new THREE.MeshPhysicalMaterial({
    map: tex.pegWood,
    roughnessMap: tex.pegRough,
    color: new THREE.Color('#5a3220'),
    roughness: 0.55,
    metalness: 0.04,
    clearcoat: 0.12,
    clearcoatRoughness: 0.6,
  });

  const skin = new THREE.MeshPhysicalMaterial({
    map: tex.skin,
    roughnessMap: tex.skinRough,
    bumpMap: tex.skinBump,
    bumpScale: 0.0018,
    color: new THREE.Color('#cbb58a'),
    roughness: 0.88,
    metalness: 0,
    sheen: 0.42,
    sheenColor: new THREE.Color('#e8c98a'),
    sheenRoughness: 0.78,
    clearcoat: 0.04,
    clearcoatRoughness: 0.9,
  });

  const bone = new THREE.MeshPhysicalMaterial({
    map: tex.bone,
    roughnessMap: tex.boneRough,
    color: new THREE.Color('#f3e6c8'),
    roughness: 0.38,
    metalness: 0.05,
    clearcoat: 0.35,
    clearcoatRoughness: 0.4,
    sheen: 0.2,
    sheenColor: new THREE.Color('#f0e2c0'),
  });

  const leather = new THREE.MeshPhysicalMaterial({
    map: tex.leather,
    roughnessMap: tex.leatherRough,
    color: new THREE.Color('#4a2c1c'),
    roughness: 0.78,
    metalness: 0.02,
    sheen: 0.15,
    sheenColor: new THREE.Color('#6a3a22'),
  });

  const gut = (hex, rough = 0.52) =>
    new THREE.MeshPhysicalMaterial({
      color: new THREE.Color(hex),
      roughness: rough,
      metalness: 0.04,
      sheen: 0.25,
      sheenColor: new THREE.Color('#d8b07a'),
      sheenRoughness: 0.55,
    });

  const steel = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color('#cfd5db'),
    roughness: 0.28,
    metalness: 1,
  });

  const hair = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color('#1a1612'),
    roughness: 0.62,
    metalness: 0.05,
    sheen: 0.35,
    sheenColor: new THREE.Color('#3a3228'),
    side: THREE.DoubleSide,
  });

  const wrap = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color('#1c1712'),
    roughness: 0.72,
    metalness: 0,
  });

  const velvet = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color('#2a1c14'),
    roughness: 0.92,
    metalness: 0,
    sheen: 0.85,
    sheenColor: new THREE.Color('#6a3a28'),
    sheenRoughness: 0.55,
  });

  const floor = new THREE.MeshStandardMaterial({
    color: new THREE.Color('#121114'),
    roughness: 0.9,
    metalness: 0.04,
  });

  return {
    wood,
    woodDark,
    inner,
    peg,
    skin,
    bone,
    leather,
    gutThick: gut('#c9a06a', 0.58),
    gutMid: gut('#d2ae78', 0.52),
    gutThin: gut('#ddc08a', 0.48),
    steel,
    hair,
    wrap,
    velvet,
    floor,
  };
}
